import Navigator, { NavigatorBanner } from './Navigator'
import ProcessStep from './ProcessStep'

import { useEffect, useState } from 'react'

export default function Process({ steps }) {
  const [observer, setObserver] = useState(null)

  useEffect(() => {
    const event = new Event('section-change', {
      bubbles: true,
    })

    setObserver(
      new IntersectionObserver(
        ([e]) => {
          if (
            e.isIntersecting &&
            window.location.hash.replace('#', '') !== e.target.id
          ) {
            // update url hash without scrolling
            history.replaceState(null, null, `#${e.target.id}`)
            e.target.dispatchEvent(event)
          }
        },
        { threshold: 0.5 },
      ),
    )
  }, [setObserver])

  const navigatorItems = steps.map(({ id, title }) => ({ id, title }))

  return (
    <>
      <NavigatorBanner>
        <Navigator items={navigatorItems} />
      </NavigatorBanner>
      <div>
        {steps.map((step, i) => (
          <ProcessStep
            key={step.id}
            stepNumber={i + 1}
            id={step.id}
            title={step.title}
            headline={step.headline}
            body={step.description}
            img={step.image}
            observer={observer}
          />
        ))}
      </div>
    </>
  )
}
